import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wp1200 withPadding responsiveFlex" }
const _hoisted_2 = {
  key: 0,
  class: "boxInfo"
}
const _hoisted_3 = { class: "reverse" }
const _hoisted_4 = { class: "top" }
const _hoisted_5 = { class: "mainTitle" }
const _hoisted_6 = { class: "subTitle" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", { class: "green" }, null, -1)
const _hoisted_8 = { class: "bottom" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_arrow-L" }, null, -1)
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "content" }
const _hoisted_12 = { class: "txt" }
const _hoisted_13 = { class: "row flex" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "time" }
const _hoisted_16 = { class: "day" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "icons" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_bell" }),
  /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_calendar-add" })
], -1)
const _hoisted_18 = { class: "row flex" }
const _hoisted_19 = { class: "city" }
const _hoisted_20 = { class: "place green" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "icons" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_pointer" })
], -1)
const _hoisted_22 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.event)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.event.title), 1),
              _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.event.summary), 1),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: { name: 'Events' },
                class: "responsiveBack"
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }),
              (_ctx.event.image_url !== null)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.event.image_url
                  }, null, 8, _hoisted_10))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_CalendarIcon, {
                  date: _ctx.event.datetime
                }, null, 8, ["date"]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    (_ctx.event.datetime)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$moment(_ctx.event.datetime).format("hh:mm")), 1),
                          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$moment(_ctx.event.datetime).fromNow()), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_17
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.event.city), 1),
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.event.venue), 1)
                    ]),
                    _hoisted_21
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("p", {
            class: "eventBody",
            innerHTML: _ctx.event.body
          }, null, 8, _hoisted_22)
        ]))
      : _createCommentVNode("", true)
  ]))
}